<script setup>
// Brasa "Lanterna" (direção 1 com a postura da 4, escolhida pelo Lucas em
// 23/09/2026): o mascote do onboarding num selo escuro, e a luz dele conta o
// estado. Com item esperando revisão a luz respira e as asas abrem de leve;
// em dia, a luz fica baixa e o mascote quase parado. Puramente decorativa:
// o número de verdade está no texto de quem usa o componente.
import { computed } from 'vue';
import BrasaMascot from 'dashboard/components-next/onboarding/BrasaMascot.vue';

const props = defineProps({
  // Itens esperando revisão. null = ainda carregando.
  pending: { type: Number, default: null },
  size: { type: Number, default: 64 },
});

const mood = computed(() => {
  if (props.pending === null) return 'loading';
  return props.pending > 0 ? 'attention' : 'calm';
});
// 'idle' bate as asas e flutua; 'wait' é a postura contida, halo baixo.
const mascotState = computed(() =>
  mood.value === 'attention' ? 'idle' : 'wait'
);
const mascotSize = computed(() => Math.round(props.size * 0.78));
</script>

<template>
  <span
    class="brasa-lantern"
    :class="`brasa-lantern--${mood}`"
    :style="{ width: `${size}px`, height: `${size}px` }"
    :data-mood="mood"
    data-testid="brasa-lantern"
    aria-hidden="true"
  >
    <span class="brasa-lantern__glow" />
    <BrasaMascot :state="mascotState" :size="mascotSize" />
  </span>
</template>

<style scoped>
/* Selo sempre escuro, nos dois temas: a luz da Brasa só lê sobre fundo
   escuro. */
.brasa-lantern {
  position: relative;
  display: inline-grid;
  flex-shrink: 0;
  place-items: center;
  overflow: hidden;
  border-radius: 28%;
  border: 1px solid #1f2a3c;
  background: #0b1019;
}
.brasa-lantern__glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    circle at 47% 70%,
    rgb(156 243 255 / 0.34),
    rgb(156 243 255 / 0) 62%
  );
  opacity: 0.35;
  transition: opacity 0.6s ease;
}
.brasa-lantern--attention .brasa-lantern__glow {
  opacity: 1;
  animation: brasa-lantern-breathe 4.5s ease-in-out infinite;
}
.brasa-lantern > :deep(svg) {
  position: relative;
}
@keyframes brasa-lantern-breathe {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}
@media (prefers-reduced-motion: reduce) {
  .brasa-lantern--attention .brasa-lantern__glow {
    animation: none;
  }
}
</style>
